import { Household } from '@/features/household/models/household';
import {
    CreateHouseholdDTO,
    HouseholdDTO,
    UpdateHouseholdNameDTO,
    UpdateHouseholdSettingsDTO,
} from '@/features/household/dto/household_dto';
import {
    CreateHouseholdForm,
    UpdateHouseholdNameForm,
    UpdateHouseholdSettingsForm,
} from '@/features/household/form/household_form';

export function fromHouseholdDTO(dto: HouseholdDTO): Household {
    return {
        id: dto.id,
        name: dto.name,
        countryCode: dto.country_code,
        languageCode: dto.language_code,
        timezone: dto.timezone,
        defaultCurrency: dto.default_currency,
        type: dto.type,
        createdAt: dto.created_at,
        updatedAt: dto.updated_at,
    }
}

export function toHouseholdDTO(household: Household): HouseholdDTO {
    return {
        id: household.id,
        name: household.name,
        country_code: household.countryCode,
        language_code: household.languageCode,
        timezone: household.timezone,
        default_currency: household.defaultCurrency,
        type: household.type,
        created_at: household.createdAt,
        updated_at: household.updatedAt,
    }
}

export function toCreateHouseholdDTO(form: CreateHouseholdForm): CreateHouseholdDTO {
    return {
        name: form.name,
        country_code: form.countryCode,
        language_code: form.languageCode,
        timezone: form.timezone,
        default_currency: form.defaultCurrency,
    }
}

export function toUpdateHouseholdNameDTO(form: UpdateHouseholdNameForm): UpdateHouseholdNameDTO {
    return {
        name: form.name,
    }
}

export function toUpdateHouseholdSettingsDTO(form: UpdateHouseholdSettingsForm): UpdateHouseholdSettingsDTO {
    return {
        country_code: form.countryCode,
        language_code: form.languageCode,
        timezone: form.timezone,
        default_currency: form.defaultCurrency
    }
}
